import { Dispatch } from "redux"
import { getStudentFeesDetails } from "../../services/studentFeesDetails"
import { camelize } from "../../config/functions"


export interface StudentFeeDetailsParams{
    branchId:string
    courseId:string
    batch:string
    year:string
    admissionNumber:string
}
export interface FeeItem {
    title: string;
    amount: number;
    paid: number;
    balance: number;
}


export interface StudentFeeDetails{
    studentId?: number;
    studentName?: string;
    registerNumber?: string;
    admissionNumber?: string;
    batch?: string;
    branchName?: string;
    courseName?: string;
    academicPeriod?:string;
    totalAmount?:string;
    totalPaid?:string;
    totalBalance?:string;
    fees: FeeItem[]; 
}

export enum StudentFeeDetailsActionList{
    FETCH_STUDENT_FEE_DETAILS = "FETCH_STUDENT_FEE_DETAILS",
    CLEAR_STDUENT_FEE_DETAILS = "CLEAR_STUDENT_FEE_DETAILS"
}

export interface FetchStudentFeeDetailsAction{
    type:StudentFeeDetailsActionList.FETCH_STUDENT_FEE_DETAILS
    data:StudentFeeDetails[]
}

export interface ClearStudentFeeDetailsAction{
    type:StudentFeeDetailsActionList.CLEAR_STDUENT_FEE_DETAILS
}

export type StudentFeeDetailsActions = |FetchStudentFeeDetailsAction|ClearStudentFeeDetailsAction;

// In studentFeesDetailsAction.ts - fetchStudentFeeDetailsAction

export const fetchStudentFeeDetailsAction = (params: StudentFeeDetailsParams) => {
    return async (dispatch: Dispatch) => {
        
        return getStudentFeesDetails(params)
            .then(response => {
                if (response.status === 200 && response.data.data) {
                    const data = response.data.data.map((res: any) => {
                        let camelCase: any = {}
                        for (let i = 0; i < Object.keys(res).length; i++) {
                            const key = camelize(Object.keys(res)[i])
                            const value = Object.values(res)[i]
                            camelCase = { ...camelCase, [key]: value }
                        }
                        return camelCase  
                    });
                    dispatch<FetchStudentFeeDetailsAction>({
                        type: StudentFeeDetailsActionList.FETCH_STUDENT_FEE_DETAILS,
                        data
                    });
                    return Promise.resolve("Student fees details fetched successfully");
                } else {
                    console.error(" API returned non-200:", response);
                    throw response;
                }
            })
            .catch(error => {
               
                console.error(" Full Error Object:", error);
                console.error(" Error Response:", error?.response);
                console.error(" Error Message:", error?.response?.data?.message);
                console.error(" Error Status:", error?.response?.status);
                
                const errorMsg = error?.response?.data?.message 
                    || error?.response?.data?.error 
                    || error?.message 
                    || "Unknown error";
                    
                return Promise.reject(errorMsg);
            });
    };
};
export const ClearStudentFeeDetailsAction = () => {
    return(dispatch:Dispatch)=>{
        dispatch<ClearStudentFeeDetailsAction>({
             type:StudentFeeDetailsActionList.CLEAR_STDUENT_FEE_DETAILS
        });
    };
};